import React from 'react';
import PropTypes from 'prop-types';

import Team from '@views/Team';
import './BracketPodium.css';

const PodiumPlaceholder = () => (
  <span className="podium-placeholder">A definir</span>
);

export const BracketPodium = ({ teams }) => (
  <div className="bracket-podium">
    <div className="match">
      <div className="podium-title">Segundo</div>

      <div className="team">
        <div className="participant">
          <div className="name">
            {teams[1] ? <Team code={teams[1]} /> : <PodiumPlaceholder />}
          </div>
        </div>
      </div>
    </div>
    <div className="match champion">
      <div className="podium-title">Campeón</div>
      <div className="team">
        <div className="participant">
          <div className="name">
            {teams[0] ? <Team code={teams[0]} /> : <PodiumPlaceholder />}
          </div>
        </div>
      </div>
    </div>
    <div className="match">
      <div className="podium-title">Tercero</div>
      <div className="team">
        <div className="participant">
          <div className="name">
            {teams[2] ? <Team code={teams[2]} /> : <PodiumPlaceholder />}
          </div>
        </div>
      </div>
    </div>
  </div>
);

BracketPodium.displayName = 'BracketPodium';
BracketPodium.propTypes = {
  teams: PropTypes.arrayOf(PropTypes.string),
};

export default BracketPodium;
